import { IconButton } from "@material-ui/core";
import { CloseIcon } from "../../../../icons";
import { Color } from "../../../../theme";
import { ClearIndicatorProps, GroupBase } from "react-select5";

export function ClearIndicatorComponent<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: ClearIndicatorProps<Option, IsMulti, Group> & { onClear?: () => void }) {
  const {
    innerProps: { ref, ...restInnerProps }
  } = props;

  return (
    <div
      {...restInnerProps}
      ref={ref}
      onMouseDown={(e) => {
        props.onClear && props.onClear();
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <IconButton style={{ padding: 0, width: "1rem", height: "1rem", bottom: "2px" }}>
        <CloseIcon htmlColor={Color.Body} style={{ width: "14px", height: "14px" }} />
      </IconButton>
    </div>
  );
}
